import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import SiteHeader from '../components/SiteHeader'
import Breadcrumbs from '../components/Breadcrumbs'
import {
    MDBAnimation,
    MDBContainer,
    MDBRow,
    MDBDatatable,
    MDBBtn,
    MDBIcon,
    MDBCol,
    MDBModal,
    MDBModalDialog,
    MDBModalContent,
    MDBModalHeader,
    MDBModalTitle,
    MDBModalBody,
    MDBModalFooter,
    MDBInput,
    MDBSelect,
} from 'mdb-react-ui-kit'
import encryption from '../services/encryption'
import activityTypeService from '../services/activityTypes'
import formService from '../services/forms'
import modulePermissions from '../utilities/modulePermissions'
import auth from '../services/authentication'

export default function ActivityTypes() {

    const moduleName = 'activity-type';
    const navigateTo = useNavigate();
    const { version_id } = useParams();
    const [selectedProfile, setSelectedProfile] = useState(null);

    const [formList, setFormList] = useState([]);
    const [activityTypeCategoryList, setActivityTypeCategoryList] = useState([]);
    const [modalAddShow, setModalAddShow] = useState(false);
    const [modalEditShow, setModalEditShow] = useState(false);
    const [modalDeleteShow, setModalDeleteShow] = useState(false);
    const [entryId, setEntryId] = useState(null);
    const [state, setState] = useState({
        version_id: version_id,
        form_id: null,
        activityTypeName: '',
        activityTypeDescription: '',
        activityTypeCategory: 'self-evaluation',
    });

    const [modules, setModules] = useState({});

    const breadCrumbsData = [
        {
            text: 'Inicio',
            href: `/home`
        },
        {
            text: 'Versiones',
            href: `/version/${version_id}`
        },
        {
            text: 'Tipos de Actividad',
        }
    ];

    const handleSelectedProfile = () => {
        let token = localStorage.getItem('selectedProfile');
        if (token) {
            let descryptedToken = encryption.decrypt(token);
            setSelectedProfile(descryptedToken);
        }
    }

    const toggleAddModal = () => {
        if (modalAddShow === false) {
            setState({
                version_id: version_id,
                activityTypeName: '',
                activityTypeDescription: '',
                activityTypeCategory: 'self-evaluation',
            });
        }
        setModalAddShow(!modalAddShow);
    }

    const toggleEditModal = (newState) => {
        setModalEditShow(newState);
    }

    const toggleDeleteModal = (newState) => {
        setModalDeleteShow(newState);
    }

    const btnActionEdit = (item, id) => {
        let newState = { ...item };
        delete newState.id;
        setEntryId(id);
        setState(newState);
        toggleEditModal(true);
    }

    const btnActionDelete = (item, id) => {
        let newState = { ...item };
        delete newState.id;
        setEntryId(id);
        setState(newState);
        toggleDeleteModal(true);
    }

    const [asyncData, setAsyncData] = useState({
        columns: [
            {
                label: 'ID',
                field: 'id',
            },
            {
                label: 'Nombre',
                field: 'activityTypeName',
            },
            {
                label: 'Acciones',
                field: 'actions',
            },
        ],
        rows: []
    });

    const [dataLoading, setDataLoading] = useState(false);

    const handleFormListLoad = async () => {
        const forms = await formService.listByVersion(version_id);
        setFormList(forms);
    }

    const handleDataLoad = async () => {
        handleFormListLoad();
        const activityTypes = await activityTypeService.listByVersion(version_id)
        setAsyncData({
            columns: asyncData.columns,
            rows: activityTypes.map((item, index) => {
                return {
                    id: index + 1,
                    activityTypeName: item.activityTypeName,
                    actions: <>
                        {
                            selectedProfile && modules?.activityTypes?.includes('update') && (
                                <MDBBtn color='info' size='lg' className='me-2' floating onClick={() => btnActionEdit(item, item.id)}>
                                    <MDBIcon icon='edit' />
                                </MDBBtn>
                            )
                        }
                        {
                            selectedProfile && modules?.activityTypes?.includes('delete') && (
                                <MDBBtn color='danger' size='lg' className='me-2' floating onClick={() => btnActionDelete(item, item.id)}>
                                    <MDBIcon icon='trash' />
                                </MDBBtn>
                            )
                        }
                        {
                            selectedProfile && modules?.activityTypes?.includes('internal') && (
                                <MDBBtn
                                    color='secondary'
                                    size='lg'
                                    floating
                                    type='button'
                                    onClick={() => {
                                        navigateTo(`/${moduleName}/${item.id}`);
                                    }}
                                >
                                    <MDBIcon icon='eye' />
                                </MDBBtn>
                            )
                        }
                    </>
                }
            })

        })
    }

    const handleCreate = async () => {
        await activityTypeService.create(state);
        handleDataLoad();
        toggleAddModal();
        setState({
            version_id: version_id,
            form_id: null,
            activityTypeName: '',
            activityTypeDescription: '',
            activityTypeCategory: 'self-evaluation',
        });
    }

    const handleUpdate = async () => {
        await activityTypeService.update(entryId, {
            ...state
        });
        handleDataLoad();
        toggleEditModal(false);
    }

    const handleDelete = async () => {
        await activityTypeService.remove(entryId);
        handleDataLoad();
        setState({
            version_id: version_id,
            form_id: null,
            activityTypeName: '',
            activityTypeDescription: '',
            activityTypeCategory: 'self-evaluation',
        });
        toggleDeleteModal(false);
    }

    useEffect(() => {
        handleSelectedProfile();
    }, []);

    useEffect(() => {
        handleDataLoad();
    }, [dataLoading, asyncData.columns, modules, selectedProfile]);

    useEffect(() => {
        if (asyncData.rows.length === 0) {
            setDataLoading(true);
        } else {
            setDataLoading(false);
        }
    }, [asyncData.rows]);

    useEffect(() => {
        setActivityTypeCategoryList([
            {
                value: 'self-evaluation',
                text: 'Autodiagnóstico',
                defaultSelected: 'self-evaluation' == state.activityTypeCategory
            },
            {
                value: 'generic',
                text: 'Genérico',
                defaultSelected: 'generic' == state.activityTypeCategory
            },
            {
                value: 'component',
                text: 'Componente',
                defaultSelected: 'component' == state.activityTypeCategory
            }
        ]);
    }, [state.activityTypeCategory]);

    const handlePageModules = async () => {
        let modulesData = {};
        modulesData = {
            activityTypes: []
        }
        let available = false;

        available = await modulePermissions(selectedProfile.roleName, 'activityTypes', 'create');
        if (available) modulesData.activityTypes.push('create');
        available = await modulePermissions(selectedProfile.roleName, 'activityTypes', 'update');
        if (available) modulesData.activityTypes.push('update');
        available = await modulePermissions(selectedProfile.roleName, 'activityTypes', 'delete');
        if (available) modulesData.activityTypes.push('delete');
        available = await modulePermissions(selectedProfile.roleName, 'activityTypes', 'internal');
        if (available) modulesData.activityTypes.push('internal');

        setModules(modulesData);
    }

    useEffect(() => {
    }, [modules]);

    useEffect(() => {
        if (selectedProfile) {
            handlePageModules();
        }
    }, [selectedProfile]);

    return (
        <>
            <SiteHeader
                selectedProfile={selectedProfile}
            />
            <MDBAnimation
                animation='fade-in'
                start='onLoad'
                duration={700}
            >
                <MDBRow className='my-4 ms-4'>
                    <Breadcrumbs
                        items={breadCrumbsData}
                    />
                </MDBRow>
                <MDBContainer>
                    <MDBRow className='my-4 ms-4'>
                        <h4>Tipos de Actividad</h4>
                    </MDBRow>
                    {
                        selectedProfile && modules?.activityTypes?.includes('create') && (
                            <MDBRow className='text-end'>
                                <MDBCol className='me-0 pe-0'>
                                    <MDBBtn color='primary' className='my-4' size='lg' floating onClick={() => {
                                        toggleAddModal();
                                    }}>
                                        <MDBIcon icon='plus' />
                                    </MDBBtn>
                                </MDBCol>
                            </MDBRow>
                        )
                    }
                    <MDBRow>
                        <MDBDatatable
                            data={asyncData}
                            rowsText='Filas'
                            ofText='de'
                            searchLabel='Buscar'
                            search
                            noFoundMessage='No se encontraron resultados'
                            isLoading={dataLoading}
                            searchInputProps={
                                {
                                    'className': 'pb-1',
                                }
                            }
                        />
                    </MDBRow>
                </MDBContainer>
            </MDBAnimation>

            <MDBModal tabIndex='-1' show={modalAddShow} setShow={setModalAddShow}>
                <MDBModalDialog centered>
                    <MDBModalContent>
                        <MDBModalHeader>
                            <MDBModalTitle>Agregar tipo de actividad</MDBModalTitle>
                            <MDBBtn className='btn-close' color='none' onClick={toggleAddModal}></MDBBtn>
                        </MDBModalHeader>
                        <MDBModalBody>
                            <input type='hidden' value={state.version_id} />
                            <MDBInput
                                label='Nombre tipo de actividad'
                                value={state.activityTypeName}
                                onChange={(e) => {
                                    setState({
                                        ...state,
                                        activityTypeName: e.target.value
                                    });
                                }}
                                className='mb-4'
                            />
                            <MDBInput
                                label='Descripción tipo de actividad'
                                value={state.activityTypeDescription}
                                onChange={(e) => {
                                    setState({
                                        ...state,
                                        activityTypeDescription: e.target.value
                                    });
                                }}
                                className='mb-4'
                            />
                            <MDBSelect
                                label='Categoría'
                                data={activityTypeCategoryList}
                                onValueChange={(e) => {
                                    setState({
                                        ...state,
                                        activityTypeCategory: e.value
                                    });
                                }
                                }
                            />
                        </MDBModalBody>
                        <MDBModalFooter>
                            <MDBBtn color='secondary' outline onClick={toggleAddModal}>
                                Cancelar
                            </MDBBtn>
                            <MDBBtn
                                color='primary'
                                onClick={
                                    () => {
                                        handleCreate()
                                    }
                                }

                            >Insertar
                            </MDBBtn>
                        </MDBModalFooter>
                    </MDBModalContent>
                </MDBModalDialog>
            </MDBModal>

            <MDBModal tabIndex='-1' show={modalEditShow} setShow={setModalEditShow}>
                <MDBModalDialog centered>
                    <MDBModalContent>
                        <MDBModalHeader>
                            <MDBModalTitle>Editar tipo de actividad</MDBModalTitle>
                            <MDBBtn className='btn-close' color='none' onClick={
                                () => toggleEditModal(false)
                            }></MDBBtn>
                        </MDBModalHeader>
                        <MDBModalBody>
                            <input type='hidden' value={state.version_id} />
                            <MDBInput
                                label='Nombre tipo de actividad'
                                value={state.activityTypeName}
                                onChange={(e) => {
                                    setState({
                                        ...state,
                                        activityTypeName: e.target.value
                                    });
                                }}
                                className='mb-4'
                            />
                            <MDBInput
                                label='Descripción tipo de actividad'
                                value={state.activityTypeDescription}
                                onChange={(e) => {
                                    setState({
                                        ...state,
                                        activityTypeDescription: e.target.value
                                    });
                                }}
                                className='mb-4'
                            />
                            <MDBSelect
                                label='Categoría'
                                data={activityTypeCategoryList}
                                onValueChange={(e) => {
                                    setState({
                                        ...state,
                                        activityTypeCategory: e.value
                                    });
                                }
                                }
                                className='mb-4'
                            />
                            <MDBSelect
                                label='Formulario'
                                data={
                                    formList.map((item) => {
                                        return {
                                            value: item.id,
                                            text: item.formName + ' - ver.' + item.formRevision,
                                            defaultSelected: item.id == state.form_id
                                        }
                                    })
                                }
                                onValueChange={(e) => {
                                    setState({
                                        ...state,
                                        form_id: e.value
                                    });
                                }}
                            />
                        </MDBModalBody>
                        <MDBModalFooter>
                            <MDBBtn color='secondary' outline onClick={
                                () => toggleEditModal(false)
                            }>
                                Cancelar
                            </MDBBtn>
                            <MDBBtn
                                onClick={() => {
                                    handleUpdate();
                                }}
                            >Actualizar
                            </MDBBtn>
                        </MDBModalFooter>
                    </MDBModalContent>
                </MDBModalDialog>
            </MDBModal>

            <MDBModal tabIndex='-1' show={modalDeleteShow} setShow={setModalDeleteShow}>
                <MDBModalDialog centered>
                    <MDBModalContent>
                        <MDBModalHeader>
                            <MDBModalTitle>Eliminar tipo de actividad</MDBModalTitle>
                            <MDBBtn className='btn-close' color='none' onClick={
                                () => toggleDeleteModal(false)
                            }></MDBBtn>
                        </MDBModalHeader>
                        <MDBModalBody>
                            <p>¿Está seguro que desea eliminar la tipo de actividad {state.activityTypeName}?</p>
                        </MDBModalBody>
                        <MDBModalFooter>
                            <MDBBtn color='secondary' outline onClick={
                                () => toggleDeleteModal(false)
                            }>
                                Cancelar
                            </MDBBtn>
                            <MDBBtn
                                onClick={() => {
                                    handleDelete();
                                }}
                            >Eliminar
                            </MDBBtn>
                        </MDBModalFooter>
                    </MDBModalContent>
                </MDBModalDialog>
            </MDBModal>
        </>
    )
}
